module.exports = __webpack_public_path__ + "static/media/ourDirection1.6ae8ef3d.jpg";